import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";
import { pageRoot } from "../../styles/pageRoot";

export const Container = styled.div`
  ${pageRoot}
  background-color: var(--color-background);
  color: var(--color-text);
`;

export const Main = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

export const Section = styled.section`
  margin-bottom: 3rem;

  h2 {
    font-size: ${fontSizes.xl}px;
    font-weight: var(--font-weight-semibold);
    margin-bottom: 1.5rem;
    color: var(--color-text);
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.button`
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 1rem;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:hover {
    border-color: var(--color-primary);
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }

  .icon-wrapper {
    width: 64px;
    height: 64px;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: white;

    &.tutor {
      background-color: var(--color-primary);
    }

    &.translator {
      background-color: var(--color-secondary);
    }
  }

  .content {
    flex: 1;

    h3 {
      font-size: ${fontSizes.base}px;
      font-weight: var(--font-weight-semibold);
      margin-bottom: 0.25rem;
      color: var(--color-text);
    }

    p {
      font-size: ${fontSizes.sm}px;
      color: var(--color-text-secondary);
      line-height: 1.4;
    }
  }

  .arrow {
    color: var(--color-text-secondary);
    opacity: 0.5;
  }
`;
